import React from 'react';
import { RequestForm } from './Intake';

// Public, no-login page for staff taking a request by phone. The key in the URL is the only credential.
export default function CallIntake({ keyValue }) {
  return (
    <div style={{ maxWidth: 720, margin: '0 auto', padding: '14px 14px 60px' }}>
      <div style={{ fontFamily: "'IBM Plex Sans Condensed', var(--font)", fontWeight: 600, fontSize: 18, color: 'var(--navy)', margin: '4px 2px 12px' }}>Redline new request</div>
      <RequestForm publicKey={keyValue} />
    </div>
  );
}
